import React from 'react'
import { isEmpty } from 'lodash'

import { IMG } from '../../../../themes'
import { BOOKING_STATUS, COMPANY_TOKEN_TYPE, MEETING_CANNOT_BE_EDITED, MODAL_CONFIRM } from '../../../../helpers/constants'

const DeleteIcon = ({ selectedBooking, permission, onConfirm ,language = 'EN', companyTokenType }) => {
  const isWaiting = !isEmpty(selectedBooking) && selectedBooking.status === BOOKING_STATUS.WAITING
  const hasPermission = isWaiting && permission.delete
  const modalInfo = {
    headerName: MEETING_CANNOT_BE_EDITED.HEADER[language],
    descriptionName: companyTokenType === COMPANY_TOKEN_TYPE.GOOGLE ? MEETING_CANNOT_BE_EDITED.DESCRIPTION.GOOGLE[language] : MEETING_CANNOT_BE_EDITED.DESCRIPTION.MICROSOFT[language],
    buttonName: MODAL_CONFIRM.CLOSE[language]
  }
  return (
    <img
      src={IMG[`ic_delete_${hasPermission && selectedBooking.isEditable ? 'black' : 'gray'}.svg`]}
      style={{ cursor: hasPermission && selectedBooking.isEditable  ? 'pointer' : 'not-allowed' }}
      alt='trash'
      onClick={() => hasPermission || !selectedBooking.isEditable ? onConfirm(event, modalInfo) : null}
    />
  )
}

export default DeleteIcon
